export default __webpack_public_path__ + "static/media/1976.72f4225a.png";